import _extends from "@babel/runtime/helpers/esm/extends";
var _g, _defs;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgBolt = function SvgBolt(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_g || (_g = /*#__PURE__*/_jsx("g", {
      clipPath: "url(#bolt_svg__a)",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0h35.961v35.961H0V0Zm17.984 9.4c-3.264.007-5.902 2.662-5.912 5.948-.01 3.3 2.638 5.969 5.922 5.969 3.24 0 5.896-2.666 5.896-5.928 0-3.31-2.645-5.996-5.906-5.989Zm0 7.865a1.9 1.9 0 0 1-.014-3.802 1.892 1.892 0 0 1 1.899 1.892c0 1.054-.843 1.91-1.885 1.91Zm.007 9.296a1.918 1.918 0 0 0 1.912-1.972h.004a1.913 1.913 0 0 0-1.933-1.924 1.926 1.926 0 0 0-1.916 1.91c-.01 1.137.894 1.996 1.933 1.986Z",
        fill: "currentColor"
      })
    })), _defs || (_defs = /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "bolt_svg__a",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0h35v35H0z"
        })
      })
    }))]
  }));
};
export default SvgBolt;